import { ModalMessageComponent } from './../../../../shared/modais/modal-message/modal-message.component';
import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  OnChanges,
  AfterViewInit,
} from '@angular/core';

import { DadoSimulacao } from './../model/dado-simulacao';
import { PropostaSimulacao } from './../model/proposta/proposta-simulacao';
import { Parcela } from './parcela';
import { TipoPagamentoEnum } from '../../../../produtos/shared/enums/tipo-pagamrnto.enum';

@Component({
  selector: 'parcela',
  templateUrl: './parcela.component.html',
  styleUrls: ['./parcela.component.css'],
})
export class ParcelaComponent implements OnChanges, AfterViewInit {
  @Input() proposta: PropostaSimulacao;
  @Input() simulacao: DadoSimulacao;
  @Input() parcelasSimuladas: Parcela[];

  @Output() simular: EventEmitter<boolean> = new EventEmitter();
  @Output() parcelaSelecionadaChange = new EventEmitter<boolean>();

  @ViewChild('modalMessage', { static: true })
  modalMessage: ModalMessageComponent;

  public parcelaSelecionada: Parcela;

  ngOnChanges() {
    if (!this.parcelasSimuladas || !this.parcelasSimuladas.length) {
      this.parcelaSelecionadaChange.emit(false);
      return;
    }

    if (!this.parcelaSelecionada) {
      this.parcelaSelecionada =
        this.parcelasSimuladas[this.parcelasSimuladas.length - 1];

      // TODO: Pedir para o Oda verificar essa lógica
      if (this.parcelaSelecionada) {
        this.onSelectParcela(this.parcelaSelecionada);
        return;
      }
    } else {
      const parcelaAtualizada =
        this.parcelasSimuladas.find(
          (p) => p.getQuantidade() === this.parcelaSelecionada.getQuantidade()
        ) || this.parcelasSimuladas[this.parcelasSimuladas.length - 1];

      if (parcelaAtualizada) {
        this.parcelaSelecionada = parcelaAtualizada;
        this.onSelectParcela(parcelaAtualizada);
        return;
      }
    }

    this.parcelaSelecionadaChange.emit(false);
  }

  ngAfterViewInit(): void {
    if (!this.parcelaSelecionada) {
      setTimeout(() => {
        this.parcelaSelecionada =
          this.parcelasSimuladas[this.parcelasSimuladas.length - 1];

        if (this.parcelaSelecionada) {
          this.onSelectParcela(this.parcelaSelecionada);
        }
      });
    }
  }

  onSelectParcela(parcela: Parcela) {
    this.parcelaSelecionada = parcela;
    this.simulacao.setParcelas(parcela.getQuantidade());
    this.proposta.getTaxaClinte().valorParcela = parcela.getValor();
    this.proposta.getTaxaClinte().parcelas = parcela.getQuantidade();
    this.proposta.getTaxaClinte().taxaFinal = parcela.getTaxa();
    this.proposta.getTaxaClinte().fator = parcela.getFator();
    this.proposta.getTaxaClinte().valorLiberado = parcela.getValorTotal();
    this.proposta.getTaxaClinte().periodicidadePagamento =
      parcela.getPeriodicidadePagamento();
    this.proposta.getTaxaClinte().tipoPagamento = TipoPagamentoEnum.MENSAL;
    this.parcelaSelecionadaChange.emit(true);
  }

  onChangePrimeiraParcela(data) {
    this.simulacao.setPrimeiraParcela(data);
    this.simular.emit(true);
  }
}
